import { render, staticRenderFns } from "./CoolTable.vue?vue&type=template&id=5f7de1aa&"
import script from "./CoolTable.vue?vue&type=script&lang=js&"
export * from "./CoolTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f7de1aa')) {
      api.createRecord('5f7de1aa', component.options)
    } else {
      api.reload('5f7de1aa', component.options)
    }
    module.hot.accept("./CoolTable.vue?vue&type=template&id=5f7de1aa&", function () {
      api.rerender('5f7de1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/CoolTable.vue"
export default component.exports